<template>
  <div class="live-tool" >
    <!-- <div class="item2" v-if="liveStatus === 1||liveStatus === 2">
      <img src="@assets/img/live/start.png" />
      <div>焦点</div> 
    </div>         -->
    <!-- 直播隐藏v-if="liveStatus === 1||liveStatus === 2" -->
    <div class="item2 s-red z-side" @click="toggle"  v-if="liveStatus === 1||liveStatus === 2" > 
      <img src="@assets/img/live/hot.png" />
      <div>热榜</div>
      <div class="list hot-rigth" v-if="show && hotTop.length">
        <van-swipe class="list-box" vertical :show-indicators="false">
          <van-swipe-item v-for="(item, index) in hotTop" :key="'list-box-' + index">
            <div class="item3">
              <img
                class="logo"
                :src="item.targetInfo.logo"
                v-if="item.targetInfo.logo"
              />
              <img
                class="logo"
                src="@/assets/img/empty.png"
                v-else
              />
              <div class="content">
                <p>{{item.targetInfo.name}}</p>
                <div class="txt">{{item.targetInfo.name}}</div>
                <div class="tag">
                  <div class="info_img">
                  <template v-for="(item,index) in item.userInfos.slice(0,3)">
                    <img :src="item.avatarUrl" v-if="item.avatarUrl" :key="'i'+index"/>
                    <img src="@/assets/img/empty.png" v-else :key="'i'+index"/>
                  </template>
                  </div>
                  <span>{{getCount(item.userCount)}}</span>
                  <!-- <i class="icon iconfont icon-huo"></i>10705 -->
                </div>
              </div>
            </div>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <!-- <div class="item" @click="skipClick">
      <img src="@assets/img/live/gba.png" class="img1" />
    </div> -->
    <div class="item" @click="scheduleClick">
      <img src="@assets/img/live/date.png" class="img2" />
    </div>
    <div class="item"  @click="shareClick">
      <img src="@assets/img/live/share.png" class="img3" />
    </div>
    <!-- 留言输入框 -->
    <!-- <div class="input_mask" v-if="isFocus"  @click="inputClose"></div>
    <van-field
      class="input_focus"
      v-if="isFocus"
      v-model="text"
      center
      clearable
      @keyup.enter.native="inputImport"
      placeholder="说点什么..."
      placeholder-class="input_place"
      type="text"
      ref="barInput"
    >
      <template #button>
        <van-button size="small" @click="send" type="primary">发送</van-button>
      </template>
    </van-field> -->
    <!-- 分享 -->
    <liveShare ref="liveShare"></liveShare>   
    <!--  助力热榜 -->
    <hotList ref="hotList"></hotList>
    <!-- 日程 -->
    <liveSchedule ref="liveSchedule"></liveSchedule>
    <!-- 直播攻略 -->
    <liveGba ref="liveGba"></liveGba>
  </div>
  
</template>

<script>
import liveShare from "@/components/live-share/index";
import liveGba from "@/components/live-gba/index";
import hotList from "@/components/hot-list/index";
import liveSchedule from "@/components/live-schedule/index";
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
  name: "live-tool",
  props: {
    liveStatus: {
      type: Number,
      default: ()=> {return 0}
    }
  },
  data() {
    return {
      show: false,
      isZindex:false,
      timer:null,
      timeout:null,
      shareV:{
        content:'',
        poster:'',
      },
      isShareV:false,
      hotTop:[],
    };
  },
  components: {
    liveShare,
    liveGba,
    hotList,
    liveSchedule
  },
  computed: {
     ...mapGetters({
      viewer: "getViewer",
      viewerId: "getViewerId",
      roomInfo: "getRoomInfo",
      exhibitionInfo:'getExhibitionInfo',
      exhibitionId:'getExhibitionId',
      roomId:"getRoomid"
    }),
    option() {  // 获取热榜第一名
      return {
        roomId: this.roomId,
        page: 1,
        size: 1,
        userNum: 3
      };
    }
  },
  created(){
    this.time();
    this.getShareData();
  },
  mounted(){
    
  },
  methods: {
    ...mapActions({
      getShareConfig:'wxShare/getShareConfig',
      getHotList:'company/getHotList',
    }),
    async getShareVal(){
      let res = await this.getShareConfig(this.exhibitionId);
      if(res&&res){
        this.shareV=JSON.parse(res);
      }
      this.isShareV=true;
    },
    async getShareData(){
      await this.getShareVal();
      let shareData={
        title:this.shareV.content?this.shareV.content:'诚邀您参观 '+this.exhibitionInfo.name+'线上展',
        desc:this.exhibitionInfo.remark||'',
        imgUrl:this.exhibitionInfo.logo
      }
      this.$nextTick(()=>{
        this.$refs.liveShare.shareTo(shareData);
      })
    },
    async gethotListTop(){
      this.hotTop = [];
      const list = await this.getHotList(this.option);
      if(list.items && list.items.length){
        list.items.map(c => {
          if(c.targetInfo){
            c.targetInfo = JSON.parse(c.targetInfo)
          }
          if(c.userInfos.length){
            let arr =[];
            c.userInfos.map(v=>{
              if(v.indexOf("{") !== -1){
                v = JSON.parse(v);
                arr.push(v);
              }
            })
            c.userInfos = arr;
          }
        });
        this.hotTop.push(...list.items);
      }
      console.log(this.hotTop,'this.hotTop')
    },
    //分享点击
    async shareClick(){
      if(!this.isShareV){
        await this.getShareVal();
      }
      let opt={
        title:'给您推荐一个线上展会',
        bannerTitle:this.exhibitionInfo.name||this.exhibitionInfo.shortName||'线上展会',
        subhead:'主题线上展',
        bannerUrl:this.shareV.poster?this.shareV.poster:(this.exhibitionInfo.logo||''),
        // bannerUrl:this.exhibitionInfo.logo,
      }
      this.$refs.liveShare.open(opt);
    },
    //助力点击
    toggle() {
      // this.show = !this.show;
      this.$refs.hotList.open();
    },
    //日程点击
    scheduleClick(){
      this.$refs.liveSchedule.open();
    },
    //攻略点击
    skipClick(){
      this.$refs.liveGba.open();
    },
    time(){
      this.timer = setInterval(()=> {
        this.gethotListTop();
        this.show = true;
        this.showTime();
      }, 1000*5*60);
    },
    showTime(){
      this.timeout = setTimeout(()=> {
        this.show = false;
      }, 1000*10);
    },
    // 人数超过w换算
    getCount(param) {
      let count = 0;
      if (param > 10000) {
        count = (param / 10000).toFixed(1);
        if (String(count)[count.length - 1] == 0) {
          count = (count / 1).toFixed(0);
        }
        return count + "w";
      }
      return param;
    },
  },
  destroyed(){
    clearTimeout(this.timeout);
    clearInterval(this.timer);
  }
};
</script>

<style scoped lang="scss">
.live-tool {
  position: absolute;
  z-index: 1002;
  bottom: 1.18rem;
  right: 0.2rem;
  display: flex;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  width: 0.92rem;
  justify-content: center;
  .item {
    width: 0.76rem;
    height: 0.76rem;
    border-radius: 50%;
    background-color: rgba(#000, 0.4);
    text-align: center;
    line-height: 0.76rem;
    align-items: center;
    justify-content: center;
    margin-top: 0.3rem;
    position: relative;
    img {
      transform: translate(-50%,-50%);
      left: 50%;
      top:50%;
      position: absolute;
    }
  }
  .item2 {
    width: 0.92rem;
    height: 0.92rem;
    background: #fff;
    border-radius: 50%;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    flex-wrap: wrap;
    color: #ff416c;
    padding-top: 0.1rem;
    margin-top: 0.3rem;

    img {
      display: block;
      width: 0.4rem;
      height: 0.4rem;
    }
    div {
      width: 100%;
      font-size: 0.2rem;
    }
    &.s-red {
      background-image: linear-gradient(90deg, #ff416c 0%, #ff4b2b 100%),
        linear-gradient(#fff, #fff);
      color: #fff;
    }
  }
  // .input_focus {
  //   height: 0.98rem;
  //   line-height: 0.98rem;
  //   width: 100%;
  //   padding:0 0.28rem;
  //   border-radius: 0;
  //   border: none;
  //   background: #fff;
  //   color: #000;
  //   position: fixed;
  //   bottom: 0;
  //   left: 0;
  //   right: 0;
  //   .van-field__control{
  //     height: 100%;
  //     line-height: 1;
  //     font-size: 0.3rem;
  //   }
  //   &.input_place {
  //     color: #bfbfbf;
  //     font-size: 0.30rem;
  //   }
  // }
  // .input_mask {
  //   position: fixed;
  //   z-index: 100;
  //   top: 0;
  //   right: 0;
  //   left: 0;
  //   bottom: .98rem;
  //   background: rgba(0, 0, 0, 0.0);
  //   transition: all 0.3s;
  //   opacity: 1;
  // }
  
}
.img1 {
  width: 0.35rem;
  height: 0.43rem;
}
.img2 {
  width: 0.4rem;
  height: 0.38rem;
}
.img3{
  width: 0.37rem;
  height: 0.4rem;
}
.z-side {
  position: relative;
  .list {
    flex: 1;
    width: 3.33rem !important;
    height: 0.92rem;
    position: absolute;
    right: 1.02rem;
    top: 0;
    .list-box {
      width: 100%;
      height: 0.92rem;
      padding-right: 0.16rem;
    }
    .item3 {
      width: 100%;
      height: 0.92rem;
      border: 0.02rem solid #e6b54a;
      border-right-color: transparent;
      background-image: url(../../assets/img/live/crown.png),
        linear-gradient(90deg, #4b1248 0%, #9e6a62 49%, #f0c27b 100%),
        linear-gradient(#2b1e08, #2b1e08);
      background-repeat: no-repeat;
      background-position: bottom right, 0% 0%;
      background-size: 0.52rem 0.52rem, auto;
      border-radius: 0.06rem;
      position: relative;
      text-align: left;
      padding: 0.1rem;
      display: flex;
      &::after {
        content: "";
        position: absolute;
        right: -0.18rem;
        top: 50%;
        margin-top: -0.1rem;
        border-width: 0.1rem;
        border-style: solid;
        border-color: transparent;
        border-left-color: #ecbe78;
      }
      .logo {
        width: 0.7rem;
        height: 0.7rem;
        border-radius: 0.02rem;
        border: 0.02rem solid #f0cc3a;
        margin-right: 0.1rem;
      }
      .content {
        width: calc(100% - 0.8rem);
        height: 0.7rem;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
        p {
          font-size: 0.2rem;
          color: #fff;
          font-weight: bold;
          margin: 0;
          width: 100%;
          line-height: 1.2;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
        }
        .txt {
          font-size: 0.16rem;
          color: #fff;
          width: 100%;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          line-height: 1.2;
        }
        .tag {
          display: flex;
          .info_img{
            width: 0.46rem;
            height: 0.2rem;
            display: flex;
            img{
              width: 0.2rem;
              height: 0.2rem;
              border-radius: 50%;
              border: 1px solid #fff;
              // object-fit: cover;
              &:nth-child(1){
                position: relative;
                z-index: 3;
              }
              &:nth-child(2){
                position: relative;
                z-index: 2;
                margin-left: -0.07rem;
              }
              &:nth-child(3){
                position: relative;
                z-index: 1;
                margin-left: -0.06rem;
              }
            }
          }
          span{
            font-size: 0.14rem;
            margin-left: 0.1rem;
            line-height: 0.2rem;
          }
        }
      }
    }
  }
}
</style>
